<template>
  <section class="user-page-login-container">
    <router-view/>
    <div class="bottom-user-container">
      <section>
        <div class="flex">
          <img src="@/assets/icon-simple.svg">
          <p>© 2020 Oh Elvas. All Rights Reserved.</p>
        </div>
      </section>
      <section>
        <div>
          <router-link to="/">Política de Privacidade</router-link>
          <router-link to="/">Política de Cookies</router-link>
        </div>
      </section>
      <section>
        <img src="@/assets/logo-portugal-2020-branco.png">
      </section>
    </div>
  </section>
</template>
<script>
export default {
  name: 'user'
}
</script>
<style lang="scss" scoped>
.user-page-login-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.bottom-user-container {
  display: flex;
  min-height: 125px;
  width: 100%;
  background: #a79374;
  z-index: 2;
  section {
    flex-grow: 1;
    display: flex;
    align-items: center;
    padding-left: 80px;
    .flex {
      display: flex;
      align-items: center;
    }
    a {
      color: white;
      display: block;
      &:first-of-type {
        margin-bottom: 8px;
      }
    }
    p {
      margin-left: 16px;
      color: #eee3d4;
    }
  }
  
  @media (max-width: 700px){
    display: grid;
    margin-right: 8px;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    padding: 25px 5%;
    width: 90%;
    div {
      width: 100%;
    }

    section {
      padding-left: 0;
    }
  }
  @media (max-width: 500px){
    margin-right: 8px;
    display: flex;
    flex-direction: column-reverse;
    gap: 48px;
    div {
      width: 100%;

      &:nth-child(2){
        a + a {
          margin-top: 24px; 
        }
      }
    }
  }
}
</style>